<template>
  <div :class="$style.container">
    <label
      :class="$style.label"
      v-color="colorFontBody"
      v-font-style="fontBody"
      >{{ label }}</label
    >
    <div :class="$style.wrapper">
      <button @click="handleGeolocate" :class="{ [$style.geolocate]: true }">
        <base-icon name="location" :class="{ [$style.rotate]: isLocating }" />
      </button>
      <form @submit.prevent="handleSubmit">
        <base-input-text
          type="text"
          name
          :class="$style.input"
          v-model="query"
          v-color="colorFontBody"
          v-font-style="fontBody"
          @focus="$emit('focus')"
          @blur="$emit('blur')"
          placeholder="Enter town, city or postcode"
        />
        <button :class="{ [$style.search]: true }">
          <base-icon name="search" :class="{ [$style.tilt]: isQuerying }" />
        </button>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    colorFontBody: {
      type: String,
      default: '',
    },
    fontBody: {
      type: Object,
      default: () => {},
    },
    geolocationLoadingStatus: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    queryLoadingStatus: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    query: '',
  }),
  computed: {
    isSearching() {
      return (
        this.geolocationLoadingStatus === 'loading' ||
        this.queryLoadingStatus === 'loading'
      )
    },
    isLocating() {
      return this.geolocationLoadingStatus === 'loading'
    },
    isQuerying() {
      return this.queryLoadingStatus === 'loading'
    },
  },
  methods: {
    handleGeolocate() {
      if (this.isSearching) {
        return
      }
      this.$emit('geolocate')
    },
    handleSubmit() {
      if (!this.query || this.isSearching) {
        return
      }
      // TODO: animate search icon
      // this.animateSearchIcon()
      this.$emit('submitQuery', this.query)
    },
    // animateSearchIcon() {
    //   const el = this.$el.querySelector('.geolocation-input__search-icon')
    //   this.$velocity(el, { rotateZ: 10 }, { duration: 200, loop: 4 })
    // }
  },
}
</script>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 298px;
  padding-top: 32px;

  .label {
    // @extend .pmb-label;
    font-size: 16px;
    padding-bottom: 8px;
  }

  .wrapper {
    // border: 1px solid $black;
    border: 1px solid #000;
    display: flex;
    flex-direction: row;
    height: 48px;
    width: 100%;
  }

  .geolocate,
  .search {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background-color: #fff;
    padding: 10px;

    img {
      height: 100%;
      width: 100%;
    }

    &:focus {
      outline: 0;
    }
  }

  &__geolocate-icon,
  &__search-icon {
    width: 24px;
    height: 24px;
    background-color: #fff;
  }

  &__search-icon {
    transform-origin: 100% 100%;
  }

  &__geolocate-icon {
    &.--loading {
      -webkit-animation: spin 0.8s infinite linear;
      animation: spin 0.8s infinite linear;
    }
  }

  form {
    display: flex;
    flex: 1;
  }

  .input {
    border: none;
    display: flex;
    display: inline-block;
    flex: 1;
    font-size: 14px;
    height: 100%;
    line-height: 1.5;
    padding: 5px 0 0;
    text-align: center;

    &::placeholder {
      color: #868686;
      font-size: 11px;

      @media (min-width: 360px) {
        font-size: 13px;
      }
    }

    &:focus {
      outline: none;
    }
  }

  &__location-display {
    align-items: center;
    background: #fff;
    display: flex;
    height: 100%;
    justify-content: center;
    padding: 4px 0 0;
    width: 100%;

    p {
      font-size: 16px;
      text-align: center;
      line-height: 1.5;
    }
  }

  .rotate {
    animation: spin 0.8s infinite linear;
  }

  .tilt {
    animation: tilt 1s infinite linear;
  }

  @keyframes tilt {
    0% {
      transform: rotate(0deg);
      transform-origin: bottom right;
    }
    25% {
      transform: rotate(8deg);
      transform-origin: bottom right;
    }
    50% {
      transform: rotate(0deg);
      transform-origin: bottom right;
    }
    75% {
      transform: rotate(-8deg);
      transform-origin: bottom right;
    }
    100% {
      transform: rotate(0deg);
      transform-origin: bottom right;
    }
  }

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
